var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

WTE.Animal  = function() 
{
    EHDI.aka.Container.call(this);
    var MINIMUM_VISIBLE_TIME = 3500;    
    var ENTRY_TIME = 500;
    var EXIT_TIME = 500;//250;
    var EASY_TIME_OFFSET = 3000;

    this.init = function (type, gameTimeFactor, isEasySpawn)
    {
        if(!this.sprite)
            this.sprite = new EHDI.aka.Sprite();
        else
            this.sprite.removeChildren();

        this.sprite.scale.x = 1;
        this.sprite.y =0;
        this.sprite.x =0;
        if(!this.glowContainer)
            {
                this.glowContainer = new EHDI.aka.Sprite();
                this.glowContainer.y = 35;
            }

        this.glowContainer.visible = false;
        this.sprite.addChild(this.glowContainer);

        this.type =type; //int value
        var animalData = WTE.AnimalMap[type]
        this.validCage =  animalData.validCage;
        this.spriteXOffset = animalData.xOffset;
        this.spriteYOffset = animalData.yOffset;
        this.entryAnimIndex = animalData.entryIndex;
        this.idleAnimIndex = animalData.idleIndex;
        this.exitAnimIndex = animalData.exitIndex;
        this.selectedAnimIndex = animalData.selectedIndex;
        this.classification = animalData.classification;

        var minimumTime = MINIMUM_VISIBLE_TIME - gameTimeFactor;
        this.activeTime = minimumTime + (Math.random() * minimumTime);
        if(isEasySpawn)
            this.activeTime += EASY_TIME_OFFSET;
        this.timer =0;
        this.isOut = false;
        this.hasFled = false;
        this.isChosen = false;
        this.cageNumber= -1;
        this.isToDisappear =  false;
        this.isExiting = false;

        this.speed = 0;
        this.eventTimer = 0;
        this.isMatched = false;
        this.isMismatched = false;

        this.onEventTimerComplete = null;

        this.setVisual();
    }

    this.dispose = function()
    {
        this.sprite.removeChildren();

        this.sprite.scale.x = 1;
        this.sprite.y =0;
        this.sprite.x =0;
        this.sprite.rotation = 0;
        this.glowContainer.visible = false;

    }

    var sparkleAnimationName = "fx_sparkle";
    this.setVisual = function()
    {
        if(this.children.indexOf(this.sprite) == -1)
            this.addChild(this.sprite);
    
        this.armature = EHDI.DBoneFactory.createArmature(this.type+"_armature");
        this.animationSprite = this.armature.getDisplay();
        this.animList = this.armature.animation.animationList;

        
        var animLoopCount =0;
        if((this.classification == 'prowl') || (this.classification == 'bush'))
            animLoopCount =1;

        this.armature.animation.gotoAndPlay(this.animList[this.entryAnimIndex], -1, -1, animLoopCount);

        this.sparkleArmature = EHDI.DBoneFactory.createArmature("sparkle_armature");
        this.sparkleAnimationSprite = this.sparkleArmature.getDisplay();


        // this.animDataList = this.armature.animation.animationDataList;
        // this.armature.animation.gotoAndStop(this.animList[0], this.animDataList[0].duration * 0.001 - 0.001);
        // this.animationSprite.position.set(this.animationSprite.width * 0.5, this.animationSprite.height * 0.5);
    }

    this.removeVisuals = function()
    {       
        this.sprite.removeChildren();    
        EHDI.DBoneFactory.destroyArmature(this.armature);
    }

    this.spawn = function()
    {
    }

    this.setGlow = function(type)
    {

        var color= 'white';

        if (type == null)
            color= 'white';
        else if(type == 0)
            color= 'red';
        else
            color= 'yellow';

        var glowId = 'fx_glow_'+color;

        if((this.classification == 'prowl') || (this.classification == 'bush'))
            glowId = glowId+"2";

        this.glowContainer.texture =EHDI.Assets.images[glowId];
        this.glowContainer.anchor.set(0.5, 1); 
        
        this.glowContainer.visible = true;
    }
    
    this.toIdle = function()
    {

    }

    this.exit = function()
    {
        if(this.isExiting)
            return;

        this.sprite.scale.x = -1;
        this.isExiting = true;
        if((this.classification != 'prowl') && (this.classification != 'bush'))
            this.speed = exitSpeed;
        else    
            this.speed = 0;     
        
        this.eventTimer = EXIT_TIME;   
        this.onEventTimerComplete = this.run;

        var animLoopCount =0;
        if((this.classification == 'prowl') || (this.classification == 'bush'))
            animLoopCount =1;

        this.armature.animation.gotoAndPlay(this.animList[this.exitAnimIndex], -1, -1, animLoopCount);
    }

    this.run = function()
    {
        if(!this.isOut)
            return;

        this.disappear();
        this.hasFled = true;
        this.isChosen = false;  
        this.onEventTimerComplete = null;

    }
    

    this.update = function(delta)
    {
        // if((this.isMismatched) || (this.isMatched))
        //     {
        //         this.sprite.alpha -= (delta * (1/EXIT_TIME));

        //         if(this.isMismatched)
        //             {
        //                 this.sprite.y -= (delta * (250/EXIT_TIME));
        //             }
        //         if(this.sprite.alpha < 0)
        //             this.wasMatched();

        //         return;
        //     }

        if(this.speed != 0)
            this.sprite.x += delta * this.speed;
           
        this.timer += delta;
        if(this.eventTimer > 0)
            {
                this.eventTimer -= delta;

                if(this.eventTimer <= 0)
                    {
                        if(this.onEventTimerComplete != null)
                            this.onEventTimerComplete();
                       
                    }
            }

        // var remainingTime = this.activeTime - this.timer;
        //  if(remainingTime <= EXIT_TIME)
        //     {
        //         if(!this.isExiting)
        //             this.exit();
                
        //         if(remainingTime <= 0)
        //         {
        //             if(this.isOut)
        //                 {
        //                     this.run();
        //                     return false;
        //                 }
        //         }
        //     }

        if(this.hasFled)
            return false;

        return true;
    }

    var entrySpeed = 50/ ENTRY_TIME;
    var exitSpeed = (50/EXIT_TIME) * -1;
    this.appear = function()
    {
        this.isOut = true;
        this.sprite.addChild(this.animationSprite);
        this.addInteraction();
        this.entryTimer =0;   
        this.eventTimer = ENTRY_TIME;


        if((this.classification != 'prowl') && (this.classification != 'bush'))
            {
                this.sprite.x = -50+this.spriteXOffset;
                this.speed = entrySpeed;
            }
        else   
            {                
                this.sprite.x = this.spriteXOffset; 
                this.speed = 0;
            }
        this.sprite.y = this.spriteYOffset;
        this.onEventTimerComplete = this.hasAppeared;
    }

    this.hasAppeared =  function()
    {        
        this.sprite.x =0 + this.spriteXOffset; 
        this.speed = 0;    
        this.armature.animation.gotoAndPlay(this.animList[this.idleAnimIndex], -1, -1, 0);

        this.eventTimer = this.activeTime - this.timer - EXIT_TIME;
        this.onEventTimerComplete = this.exit;
    }

    this.disappear = function ()
    {
        this.isOut = false;        
        this.isToDisappear =  true;
        this.removeInteraction();
        this.removeVisuals();
    }

    this.match = function(isMatch)
    {
        if(isMatch)
            {
                this.isMatched = true;
                this.setGlow(1);
                
                this.armature.animation.gotoAndPlay(this.animList[this.selectedAnimIndex], -1, -1, 1);
                this.sparkleAnimationSprite.y = -100;
                this.sprite.addChild(this.sparkleAnimationSprite);

                this.sparkleArmature.animation.gotoAndPlay(sparkleAnimationName, -1, -1, 1);

                this.speed = 0;
                this.eventTimer = EXIT_TIME;  
                this.onEventTimerComplete = this.wasMatched;
            }
        else
            {
                this.isMismatched = true;
                this.setGlow(0);
                // this.armature.animation.gotoAndPlay(this.animList[1], -1, -1, 0);
                this.exit();
            }
        this.isChosen = false;
        
        this.removeInteraction();
    }

    this.wasMatched = function ()
    {
        this.isToDisappear = true;
        this.disappear();
        this.onEventTimerComplete = null;
    }
    
    
    this.addInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            this.on('touchstart', this.touched);            
        else
            this.on('mousedown', this.touched);

        this.interactive = true;
    }

    this.removeInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            this.off('touchstart', this.touched);            
        else
            this.off('mousedown', this.touched);

        this.interactive = false;
    }

    this.touched = function()
    {
        if(!this.hasFled)
            this.isChosen = true;
        
        this.armature.animation.gotoAndPlay(this.animList[this.selectedAnimIndex], -1, -1, 1);
         
    }

    this.makeSound = function()
    {
        EHDI.GAME.soundManager.playSFX(this.type);
    }


}
WTE.Animal.prototype = Object.create(EHDI.aka.Container.prototype);


WTE.AnimalKeeper = function ()
{
    var ACTIVE_COUNT = 4;
    var speciesList = WTE.AnimalMap['specieslist'];
    var bigspeciesList = WTE.AnimalMap['bigspecieslist'];
    var prowlspeciesList = WTE.AnimalMap['prowlspecieslist'];
    var bushspeciesList = WTE.AnimalMap['bushspecieslist'];

    var animalRoster = [];
    var animalBench =[];

    this.init = function()
    {
        UTILS.arrayUtils.shuffleArray(speciesList, 30);        
        UTILS.arrayUtils.shuffleArray(bigspeciesList, 10);  
        UTILS.arrayUtils.shuffleArray(prowlspeciesList, 10);
        UTILS.arrayUtils.shuffleArray(bushspeciesList, 10);

        for (var i = 0, l= speciesList.length, lim = ACTIVE_COUNT-2; (i<l && i<lim); i++)
            {
                var species = speciesList[i];

                animalRoster.push(species);
                animalRoster.push(species);
            }

        var bigspecies = bigspeciesList[0];
            animalRoster.push(bigspecies);
            animalRoster.push(bigspecies);
            
        var prowlspecies = prowlspeciesList[0];
            animalRoster.push(prowlspecies);
            animalRoster.push(prowlspecies);

            
        var bushSpecies = bushspeciesList[0];
            animalRoster.push(bushSpecies);
            animalRoster.push(bushSpecies);
        
    }

    this.releaseAnimal = function()
    {
        var randomIndex = Math.floor(Math.random() * animalRoster.length);

        var animal = animalRoster[randomIndex];
        UTILS.arrayUtils.removeFromArray(animalRoster, [animal]);

        return animal;
    }

    this.returnAnimal = function(animal, toRoster)
    {
        toRoster = true;
        if(toRoster)
            {
                animalRoster.push(animal);
                if(animalBench.length > 0)
                    this.returnAnimal(animalBench.pop(), true);
            }
        else
            animalBench.push(animal);
    }

    this.dispose = function()
    {
        if(animalRoster != null)
        {
            for(let i = 0; i < animalRoster.length; i++)
            {
                let anim =  animalRoster.pop();
                
                anim = null;
            }
            animalRoster = null;
        }

        if(animalBench != null)
        {
            for(let i = 0; i < animalBench.length; i++)
            {
                let anim =  animalBench.pop();
                anim = null;
            }

            animalBench = null;
        }
    }
    
}

